import { UiFloatModal } from '../../common/modal/index.js'
import { MSDropdown } from '../../common/dropdown/index.js';
import { getFormattedValue } from "../../../lib/utils.js";
import styles from './table.css'

const template = `
    <style>
        ${styles}
    </style>
    <div class="table-main-container">
        <table id="table">
        </table>
    </div>
`

const interpoltemplate = (scaletime) => `
<style>
    ${styles}
</style>
<div class="interpol-main-container">
    <div class="interpol-up-content">
        <select id="modal-select-upload" class="modal-select">
        </select>
        <span>X</span>
        <div class="tooltip-wrap">
            <input id="scale-input" value="${scaletime}" type="text"/>
            <div class="tooltip">${i18next.t('trend_table_scale_tooltip')}</div>
        </div>
    </div>
    <div class="btns-blue-wrapper">
        <button id="apply" class="btn-blue">${i18next.t('apply')}</button>
        <button id="cancel" class="btn-blue">${i18next.t('cancel')}</button>
    </div>
</div>
`
const createOption = (value, id, time) => `
    <option value="${id}" ${id === time ? 'selected' : ''}>${value}</option>
`


const templatebtn = `
    <style>
        ${styles}
    </style>
    <div id="trend-groups">
        <ui-dropdown id="group-tool" border="-10">
            <div slot="label" id="group-dropdown-label" class="group-dropdown-label">
                <svg width="15" height="13" viewBox="0 0 15 13" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M1 0H15V1V4V5V8V9V12V13H14H5H4H0V12V9V8V5V4V1V0H1ZM1 1L1 4H4V1L1 1ZM1 5L1 8H4L4 5H1ZM1 9L0.999999 12H4V9H1ZM5 1L14 1V4H5V1ZM5 5H14L14 8H5L5 5ZM5 9H14V12H5V9Z"/>
                </svg>
            </div>
        </ui-dropdown>
    </div>
`

const values = () => {
    return [
        { id: 'showTable', active: true, value: '', component: i18next.t('trend_table_show') },
        { id: 'interpol', active: true, value: '', component: i18next.t('trend_table_interpol') },
        { id: 'clear', active: true, value: '', component: i18next.t('trend_table_clear') },
    ]
}

const selectvalues = () => [
    { id: '1', value: `${i18next.t('interval_millisecond')}`},
    { id: '1000', value: `${i18next.t('interval_second')}`},
    { id: '60000', value: `${i18next.t('interval_minute')}`},
    { id: '3600000', value: `${i18next.t('interval_hour')}`},
    { id: '86400000', value: `${i18next.t('interval_day')}`},
    { id: '2628000000000', value: `${i18next.t('interval_month')}`},
    { id: '31540000000000', value: `${i18next.t('interval_year')}`},
]

export class TrendTable{
    constructor(root, btn){
        this.root = root
        this.btn = btn
        this.btn.innerHTML = templatebtn
        this.initDropDown()
    }

    initDropDown() {
        this.root.checkComponent('ui-dropdown', MSDropdown)
        this.dropdown = this.btn.querySelector('#group-tool')
        this.dropdown.cssElem.innerHTML += styles
        this.dropdown.childrens.style.width = 'max-content'
        this.dropdown.childrens.style.zIndex = 100
        this.dropdown.values = values()
        this.dropdown.onClick = this.dispatchAction.bind(this)
        this.dropdown.createList()
    }

    dispatchAction(e) {
        const li = e.target.closest('li')
        const Id = li?.getAttribute('Id')
        if (!li || !Id) return
        if (Id === 'showTable') this.openTableAction()
        if (Id === 'interpol') this.interpolAction()
        if (Id === 'clear') this.clearAction()
    }

    openTableAction(){
        if (!this.tableWindow) {
            this.tableWindow = new UiFloatModal(template, true, {
                left: true,
                right: true,
            });
            this.table = this.tableWindow.modalComponent.querySelector('#table')
            this.table.addEventListener('click', (e) => {
                if(this.root.autoscroll) return
                const target = e.target;
                const parent = target.parentElement;
                if(parent.tagName === "TR" && parent.attributes.data){
                    const trs = this.table.querySelectorAll('tr');
                    const isActive = parent.classList.contains("active")
                    trs.forEach((tr) => {
                        tr.classList.remove("active")
                    })
                    if(isActive){
                        this.root.tableTime = null
                    } else {
                        parent.classList.add("active")
                        this.root.tableTime = Number(parent.attributes.data.value)
                    }
                }
            })
            this.tableWindow.modalComponent.dropdown = this.dropdown
            this.tableWindow.modalComponent.calculateInitialPosition = () => {
                const { top, left } = this.dropdown.rootElem.getBoundingClientRect()
                // 20 - это дополнительный отступ, чтобы не прилипало к верху
                return [left, top + 20]
            }
            this.tableWindow.modalComponent.label = i18next.t('trend_table_lable_values')
        }
        this.tableWindow.modalComponent.toggle()
        this.updateTable();
    }

    interpolAction(){
        if (!this.interpolWindow) {
            this.interpolWindow = new UiFloatModal(interpoltemplate(this.scaletime));
            this.interpolWindow.modalComponent.dropdown = this.dropdown
            this.interpolWindow.modalComponent.calculateInitialPosition = () => {
                const { top, left } = this.dropdown.rootElem.getBoundingClientRect()
                // 20 - это дополнительный отступ, чтобы не прилипало к верху
                return [left, top + 20]
            }
            this.interpolWindow.modalComponent.label = i18next.t('trend_table_select_step')
            this.select = this.interpolWindow.modalComponent.querySelector('#modal-select-upload')
            const selectValues = selectvalues()
            for (let i = 0; i < selectValues.length; i++) {
                const elem = selectValues[i]
                const option = createOption(elem.value, elem.id, String(this.time))
                this.select.innerHTML += option
            }
            this.scaleInput = this.interpolWindow.modalComponent.querySelector('#scale-input')
            this.applybtn = this.interpolWindow.modalComponent.querySelector('#apply')
            this.cancelybtn = this.interpolWindow.modalComponent.querySelector('#cancel')
            this.applybtn.addEventListener('click', (e) => {
                this.scaletime = this.scaleInput.value
                this.time = this.select.value
                this.interpolWindow.modalComponent.close()
            })
            this.cancelybtn.addEventListener('click', (e) => {
                this.scaleInput.value = this.scaletime
                this.select.value = this.time
                this.interpolWindow.modalComponent.close()
            })
        }
        this.interpolWindow.modalComponent.toggle()
    }

    clearAction(){
        this.time = 1000
        this.scaletime = 1
        this.root.tableTime = null;
        this.updateTable()
    }
    
    toggle() {
        this.modal.modalComponent.toggle()
        if (!this.modal.modalComponent.active) return
        this.updateTable();
    }

    updateTable(){
        if(!this.tableWindow || !this.tableWindow.modalComponent.active || !this.table) return
        
        const resultTable = this.root.generateDataForTable(this.interval);
        const headerTable = resultTable[0];
        resultTable.shift()
        let head = '';
        headerTable.forEach((elem) => {
            if(elem?.color){
                head = head + `<td style="border-left: 4px solid ${elem.color}">${elem.name}</td>`
            } else {
                head = head + `<td>${elem.name}</td>`
            }
        })

        let body = '';
        this.isSelectTr = false
        resultTable.forEach((val) => {
            const timestamp = val[0]
            const formattedTime = getFormattedValue(this.root.xformat, new Date(timestamp));
            val[0] = formattedTime;
            let tr = '';
            val.forEach((element) => {
                if(typeof element === 'object') {
                    tr = tr + `<td ${element.quality === 0 || element.quality === undefined ? '' : 'class="isbad"'}>${element.text}</td>`;
                } else {
                    tr = tr + `<td>${element}</td>`; 
                }
            })
            if(timestamp !== null && !this.isSelectTr && timestamp >= this.root.tableTime && (timestamp - this.root.tableTime) <= this.interval){
                this.isSelectTr = true
                body = body + `<tr class="active" data=${timestamp}>${tr}</tr>`

            } else {
                body = body + `<tr data=${timestamp}>${tr}</tr>`
            }
        })

        this.table.innerHTML = `<tr>${head}</tr>` + body
    }

    destroy() {
        this.tableWindow?.modalComponent.delete()
        this.interpolWindow?.modalComponent.delete()
        this.tableWindow = null; 
        this.interpolWindow = null;
    }

    get time(){
        return this._time || 1000
    }
    set time (value){
        value = +value
        if(value === this._time) return
        this._time = value
        this.updateTable();
        if(this.select && this.select.value !== value){
            this.select.value = value
        }
    }

    get scaletime(){
        if(this._scaletime === undefined) return 1;
        return this._scaletime;
    }
    set scaletime (value){
        value = +value
        if(value === this.scaletime) return
        this._scaletime = value
        this.updateTable();
        if(this.scaleInput && this.scaleInput.value !== value){
            this.scaleInput.value = value
        }
    }

    get interval(){
        return this.scaletime * this.time
    }
}